<app-modal [title]="titre" size="sm" closeLabel="Fermer" (closed)="annuler()">
  <form [formGroup]="partenaireForm" class="formulaire_partenaire">
    <app-form-field [label]="libelleNom" [required]="true">
      <app-input formControlName="partnerName" [maxLength]="longueurs.nomPartenaire" />
    </app-form-field>

    <app-form-field label="Client Id (Azure)">
      <app-input formControlName="clientId" [maxLength]="longueurs.valeurInterfaceConnect" />
    </app-form-field>
  </form>

  <div appModalFooter>
    <button type="button" appButton variant="ghost" (click)="annuler()">Annuler</button>
    <button type="button" appButton variant="primary" [disabled]="!peutValider()" (click)="valider()">
      {{ estCreation ? 'Créer' : 'Enregistrer' }}
    </button>
  </div>
</app-modal>
